import React from 'react'
import Divider from '../../../../../components/Divider'
import useResize from '../../../../../hooks/useResize'
import { VIEWPORT_LG } from '../../../../../utils/constants'

const QuestionAndAnswer = ({
  questionText = '',
  answerText = '',
  answerJsx = null,
  showDivider = true,
}) => {
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  return (
    <div
      className="d-flex flex-column mt-lg-0 mt-5"
      style={{
        margin: isMobile ? '' : '0px 170px 0px 170px',
      }}
    >
      <span
        className="text-center mb-4"
        style={{
          fontSize: isMobile ? '24px' : '48px',
          fontWeight: '1000',
          color: '#001F1F',
        }}
      >
        {questionText}
      </span>
      {answerJsx ? (
        answerJsx
      ) : (
        <div className="text-on-bg-primary text-center">{answerText}</div>
      )}
      {showDivider && (
        <Divider
          className="w-100 bg-on-bg-primary"
          style={{
            opacity: '0.2',
            marginTop: '40px',
            marginBottom: '40px',
          }}
        />
      )}
    </div>
  )
}

export default QuestionAndAnswer
